import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["disabled", "availableValues", "id", "isHorizontal", "className", "controlClassName", "dataType", "value", "onValueChange"];
function ownKeys(object, enumerableOnly) {
  var keys = _Object$keys(object);
  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);
    enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
      return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { defaultAvailableValuePropType, dataTypeShape, availableValueObjectShape } from "@jutro/prop-types";
import { useTranslator } from "@jutro/locale";
import { FieldComponent } from "../FieldComponent/FieldComponent";
import { getOptionCode, getOptionName } from "../availableValues";
import styles from "./Radio.module.css";
import { messages } from "./RadioField.messages";
import { Radio } from "./Radio";
import { RadioLabel } from "./RadioLabel";
import { RadioGroup } from "./RadioGroup";
export var RadioField = function RadioField(_ref) {
  var disabled = _ref.disabled,
    _ref$availableValues = _ref.availableValues,
    availableValues = void 0 === _ref$availableValues ? defaultAvailableValues : _ref$availableValues,
    id = _ref.id,
    isHorizontal = _ref.isHorizontal,
    className = _ref.className,
    controlClassName = _ref.controlClassName,
    dataType = _ref.dataType,
    value = _ref.value,
    onValueChange = _ref.onValueChange,
    rest = _objectWithoutProperties(_ref, _excluded),
    translator = useTranslator(),
    labelClasses = cx(styles.radioFieldLabel, disabled ? styles.labelDisabled : styles.labelEnabled, isHorizontal && styles.labelHorizontal),
    labelTextClasses = cx(styles.radioFieldInnerLabels, isHorizontal ? styles.radioFieldInnerLabelsHorizontal : styles.radioFieldInnerLabelsVertical),
    secondaryLabelClasses = cx(styles.secondaryLabel, isHorizontal && styles.secondaryLabelHorizontal),
    radioGroupClasses = cx(styles.radioGroup, !isHorizontal && styles.vertical, className),
    radioGroupChildren = _mapInstanceProperty(availableValues).call(availableValues, function (option) {
      var subtitle = option.subtitle,
        _option$secondaryLabe = option.secondaryLabel,
        secondaryLabel = void 0 === _option$secondaryLabe ? subtitle : _option$secondaryLabe,
        radioValue = getOptionCode(option),
        primaryLabel = getOptionName(option);
      return React.createElement(RadioLabel, {
        key: radioValue,
        className: labelClasses
      }, React.createElement("div", {
        className: styles.iconWrapper
      }, React.createElement(Radio, {
        value: radioValue,
        iconClassName: controlClassName
      })), React.createElement("div", {
        className: labelTextClasses
      }, React.createElement("span", {
        className: styles.primaryLabel
      }, translator(primaryLabel)), secondaryLabel && React.createElement("span", {
        className: secondaryLabelClasses
      }, translator(secondaryLabel))));
    });
  return "string" === dataType ? React.createElement(RadioGroup, _extends({}, rest, {
    dataType: "string",
    value: value,
    onValueChange: onValueChange,
    disabled: disabled,
    id: id,
    className: radioGroupClasses,
    availableValues: availableValues
  }), radioGroupChildren) : "object" === dataType ? React.createElement(RadioGroup, _extends({}, rest, {
    dataType: "object",
    value: value,
    onValueChange: onValueChange,
    disabled: disabled,
    id: id,
    className: radioGroupClasses,
    availableValues: availableValues
  }), radioGroupChildren) : null;
};
var defaultAvailableValues = [{
  code: "true",
  name: messages.yes
}, {
  code: "false",
  name: messages.no
}];
RadioField.defaultProps = _objectSpread(_objectSpread({}, FieldComponent.defaultProps), {
  dataType: "string",
  isHorizontal: !1
}), RadioField.propTypes = _objectSpread(_objectSpread({}, FieldComponent.propTypes), {}, {
  id: PropTypes.string,
  value: defaultAvailableValuePropType,
  defaultValue: defaultAvailableValuePropType,
  dataType: dataTypeShape,
  availableValues: PropTypes.arrayOf(availableValueObjectShape.isRequired),
  isHorizontal: PropTypes.bool
}), RadioField.displayName = "RadioField", RadioField.__docgenInfo = {
  description: "Renders a list of radio buttons. You specify the items using component props.\n@metadataType field",
  methods: [],
  displayName: "RadioField",
  props: {
    availableValues: {
      defaultValue: {
        value: "[\n    {\n        code: 'true',\n        name: messages.yes,\n    },\n    {\n        code: 'false',\n        name: messages.no,\n    },\n]",
        computed: !1
      },
      type: {
        name: "arrayOf",
        value: {
          name: "custom",
          raw: "availableValueObjectShape.isRequired"
        }
      },
      required: !1,
      description: "Array of choice objects to display; choice objects contain 'code' and 'name'; if not provided, default 'Yes'/'No' will be used"
    },
    dataType: {
      defaultValue: {
        value: "'string'",
        computed: !1
      },
      type: {
        name: "custom",
        raw: "dataTypeShape"
      },
      required: !1,
      description: "The format of the value"
    },
    isHorizontal: {
      defaultValue: {
        value: "false",
        computed: !1
      },
      type: {
        name: "bool"
      },
      required: !1,
      description: "If true, the component will be oriented horizontally"
    },
    id: {
      type: {
        name: "string"
      },
      required: !1,
      description: "The id of the radiogroup div. Optional; auto-generated if not provided."
    },
    value: {
      type: {
        name: "custom",
        raw: "defaultAvailableValuePropType"
      },
      required: !1,
      description: "Current selected value in case of controlled components"
    },
    defaultValue: {
      type: {
        name: "custom",
        raw: "defaultAvailableValuePropType"
      },
      required: !1,
      description: "Default value"
    }
  },
  composes: ["../FieldComponent/FieldComponent"]
}, RadioField.__docgenInfo = {
  componentName: "RadioField",
  packageName: "@jutro/components",
  description: "Renders a list of radio buttons. You specify the items using component props.",
  displayName: "RadioField",
  methods: [],
  actualName: "RadioField",
  metadataType: "field",
  props: {
    id: {
      type: {
        name: "string"
      },
      required: !1,
      description: "The id of the radiogroup div. Optional; auto-generated if not provided."
    },
    value: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "bool"
        }, {
          name: "number"
        }, {
          name: "custom",
          raw: "availableValueObjectShape"
        }]
      },
      required: !1,
      description: "Current selected value in case of controlled components"
    },
    defaultValue: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "bool"
        }, {
          name: "number"
        }, {
          name: "custom",
          raw: "availableValueObjectShape"
        }]
      },
      required: !1,
      description: "Default value"
    },
    dataType: {
      type: {
        name: "enum",
        value: [{
          value: "'object'",
          computed: !1
        }, {
          value: "'string'",
          computed: !1
        }]
      },
      required: !1,
      description: "The format of the value",
      defaultValue: {
        value: "'string'",
        computed: !1
      }
    },
    availableValues: {
      type: {
        name: "arrayOf",
        value: {
          name: "union",
          value: [{
            name: "shape",
            value: {
              code: {
                name: "union",
                value: [{
                  name: "string"
                }, {
                  name: "number"
                }],
                required: !1
              },
              name: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              subtitle: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              secondaryLabel: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              }
            }
          }, {
            name: "shape",
            value: {
              id: {
                name: "union",
                value: [{
                  name: "string"
                }, {
                  name: "number"
                }],
                required: !1
              },
              displayName: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              subtitle: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              secondaryLabel: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              }
            }
          }]
        }
      },
      required: !1,
      description: "Array of choice objects to display; choice objects contain 'code' and 'name'; if not provided, default 'Yes'/'No' will be used",
      defaultValue: {
        value: "[\n    {\n        code: 'true',\n        name: messages.yes,\n    },\n    {\n        code: 'false',\n        name: messages.no,\n    },\n]",
        computed: !1
      }
    },
    isHorizontal: {
      type: {
        name: "bool"
      },
      required: !1,
      description: "If true, the component will be oriented horizontally",
      defaultValue: {
        value: "false",
        computed: !1
      }
    }
  },
  composes: ["../FieldComponent/FieldComponent"]
};